import { TripContext } from 'contexts';
import React, { FC, Fragment, useContext } from 'react';
import { useOrderItemService } from 'services';
import { OrderItemChange, ReconcileReason, RefusalReason } from 'services/types';
import './reconcile-reason.scss';

type Props = {
  orderItemsChangeId: number | undefined,
  reconcileDescription: string
  quantity: number
};

export const ReconcileReasonItem: FC<Props> = ({ orderItemsChangeId, reconcileDescription, quantity }) => {
  const { isOrderItemChangeComplete } = useOrderItemService()
  const tripContext = useContext(TripContext)

  const orderItemsChange: OrderItemChange = tripContext.orderItemChanges.find(change => change.id == orderItemsChangeId) ?? {} as OrderItemChange
  const reconcileReason: ReconcileReason = tripContext.reconcileReasons.find(reason => reason.id === orderItemsChange.reconcileReasonId) ?? {} as ReconcileReason
  const refusalReason: RefusalReason = tripContext.refusalReasons.find(reason => reason.id === orderItemsChange.refusalChoiceId) ?? {} as RefusalReason

  const textColor = (): string => {
    let fontColor: string = ''
    if (orderItemsChange) {
      fontColor = isOrderItemChangeComplete(orderItemsChange) ? '#5C5C5C' : '#EB5757'
    }
    return fontColor
  }

  return (
    <Fragment>
      <div className={'reconcile-reason-card-row'}>
        <div className={'reconcile-reason-card-text'} style={{ width: '45%', color: textColor() }}>
          <div>{reconcileDescription} </div>
          {reconcileReason.isRefusalReasonRequired &&
            <div>{refusalReason.description ?? '-'} </div>
          }
        </div>
        <div className={'reconcile-reason-card-text'} style={{ width: '40%', color: textColor() }}>
          <div>{(orderItemsChange.returnSticker) ?? '-'}</div>
          <div>{orderItemsChange.refusalComment && orderItemsChange.refusalComment}</div>
        </div>
        <div className={'reconcile-reason-card-text'} style={{ width: '15%', color: textColor() }}>{quantity} </div>
      </div>
    </Fragment >
  )
}
